import { client } from "utils/axios";
import * as yup from "yup";

export async function getAllTallasByProductInventory() {
  const { data } = await client.get("/productoTalla/stock");
  const dataTalla = data.filter((item) => item.cantidad !== null);
  return dataTalla;
}

export async function getProductTallbyId(id) {
  const { data } = await client.get(`productoTalla/filter/${id}`);
  return data;
}

export const modifyStackGarment = async (data) => {
  try {
    await client.put("productoTalla", data);
  } catch (error) {
    console.error(error);
  }
};

export const DeleteStackGarment = async (data) => {
  try {
    await client.put("productoTalla", data);
  } catch (error) {
    console.error(error);
  }
};
